// 服务支持
// ALL 所有
// IN_SEASON 当季
// LONG_TERM 长线

export default {
  planningAndBackgroundEnhancement: {
    title: '规划与背景提升',
    courseWareList: [
      {
        targetMenteeType: 'LONG_TERM',
        title: '申请规划蓝图Application Timeline-大一上',
        attachments: [
          {
            targetMenteeType: 'LONG_TERM',
            title: '申请规划蓝图Application Timeline-大一上',
            url:
              'https://res.zailairen.com/msp/docs/2.0/2.1%20%E7%94%B3%E8%AF%B7%E8%A7%84%E5%88%92%E8%93%9D%E5%9B%BEApplication%20Timeline-%E5%A4%A7%E4%B8%80%E4%B8%8A.xlsx'
          }
        ]
        // url:'https://res.zailairen.com/msp/docs/2.0/2.11%20%E7%94%B3%E8%AF%B7%E8%A7%84%E5%88%92%E8%93%9D%E5%9B%BEApplication%20Timeline-%E5%A4%A7%E4%B8%80%E4%B8%8A.pdf'
      },
      {
        targetMenteeType: 'LONG_TERM',
        title: '申请规划蓝图Application Timeline-大一下',
        attachments: [
          {
            targetMenteeType: 'LONG_TERM',
            title: '申请规划蓝图Application Timeline-大一下',
            url:
              'https://res.zailairen.com/msp/docs/2.0/2.2%20%E7%94%B3%E8%AF%B7%E8%A7%84%E5%88%92%E8%93%9D%E5%9B%BEApplication%20Timeline-%E5%A4%A7%E4%B8%80%E4%B8%8B.xlsx'
          }
        ]
        // url: 'https://res.zailairen.com/msp/docs/2.0/2.21%20%E7%94%B3%E8%AF%B7%E8%A7%84%E5%88%92%E8%93%9D%E5%9B%BEApplication%20Timeline-%E5%A4%A7%E4%B8%80%E4%B8%8B.pdf'
      },
      {
        targetMenteeType: 'LONG_TERM',
        title: '申请规划蓝图Application Timeline-大二上',
        attachments: [
          {
            targetMenteeType: 'LONG_TERM',
            title: '申请规划蓝图Application Timeline-大二上',
            url:
              'https://res.zailairen.com/msp/docs/2.0/2.3%20%E7%94%B3%E8%AF%B7%E8%A7%84%E5%88%92%E8%93%9D%E5%9B%BEApplication%20Timeline-%E5%A4%A7%E4%BA%8C%E4%B8%8A.xlsx'
          }
        ]
        // url: 'https://res.zailairen.com/msp/docs/2.0/2.31%20%E7%94%B3%E8%AF%B7%E8%A7%84%E5%88%92%E8%93%9D%E5%9B%BEApplication%20Timeline-%E5%A4%A7%E4%BA%8C%E4%B8%8A.pdf'
      },
      {
        targetMenteeType: 'LONG_TERM',
        title: '申请规划蓝图Application Timeline-大二下',
        attachments: [
          {
            targetMenteeType: 'LONG_TERM',
            title: '申请规划蓝图Application Timeline-大二下',
            url:
              'https://res.zailairen.com/msp/docs/2.0/2.4%20%E7%94%B3%E8%AF%B7%E8%A7%84%E5%88%92%E8%93%9D%E5%9B%BEApplication%20Timeline-%E5%A4%A7%E4%BA%8C%E4%B8%8B.xlsx'
          }
        ]
        // url:'https://res.zailairen.com/msp/docs/2.0/2.41%20%E7%94%B3%E8%AF%B7%E8%A7%84%E5%88%92%E8%93%9D%E5%9B%BEApplication%20Timeline-%E5%A4%A7%E4%BA%8C%E4%B8%8B.pdf'
      },
      {
        targetMenteeType: 'LONG_TERM',
        title: '申请规划蓝图Application Timeline-大三上',
        attachments: [
          {
            targetMenteeType: 'LONG_TERM',
            title: '申请规划蓝图Application Timeline-大三上',
            url:
              'https://res.zailairen.com/msp/docs/2.0/2.5%20%E7%94%B3%E8%AF%B7%E8%A7%84%E5%88%92%E8%93%9D%E5%9B%BEApplication%20Timeline-%E5%A4%A7%E4%B8%89%E4%B8%8A.xlsx'
          }
        ]
        // url: 'https://res.zailairen.com/msp/docs/2.0/2.51%20%E7%94%B3%E8%AF%B7%E8%A7%84%E5%88%92%E8%93%9D%E5%9B%BEApplication%20Timeline-%E5%A4%A7%E4%B8%89%E4%B8%8A.pdf'
      },
      {
        targetMenteeType: 'IN_SEASON',
        title: '申请规划蓝图Application Timeline-大三下',
        attachments: [
          {
            targetMenteeType: 'IN_SEASON',
            title: '申请规划蓝图Application Timeline-大三下',
            url:
              'https://res.zailairen.com/msp/docs/2.0/2.6%20%E7%94%B3%E8%AF%B7%E8%A7%84%E5%88%92%E8%93%9D%E5%9B%BEApplication%20Timeline-%E5%A4%A7%E4%B8%89%E4%B8%8B.xlsx'
          }
        ]
        // url: 'https://res.zailairen.com/msp/docs/2.0/2.61%20%E7%94%B3%E8%AF%B7%E8%A7%84%E5%88%92%E8%93%9D%E5%9B%BEApplication%20Timeline-%E5%A4%A7%E4%B8%89%E4%B8%8B.pdf'
      },
      {
        targetMenteeType: 'LONG_TERM',
        title: '长线-规划提升宝典-Industry-Oriented专业篇',
        url:
          'https://res.zailairen.com/msp/docs/2.0/2.8%20%E9%95%BF%E7%BA%BF-%E8%A7%84%E5%88%92%E6%8F%90%E5%8D%87%E5%AE%9D%E5%85%B8%20-Industry-Oriented%E4%B8%93%E4%B8%9A%E7%AF%87%20v1.0.pdf'
      },
      {
        targetMenteeType: 'LONG_TERM',
        title: '长线-规划提升宝典-Academia-Oriented专业篇',
        url:
          'https://res.zailairen.com/msp/docs/2.0/2.7%20%E9%95%BF%E7%BA%BF-%E8%A7%84%E5%88%92%E6%8F%90%E5%8D%87%E5%AE%9D%E5%85%B8%20-Academia-Oriented%E4%B8%93%E4%B8%9A%E7%AF%87%20v1.0.pdf'
      },
      {
        targetMenteeType: 'LONG_TERM',
        title: 'Valeon School School Introduction',
        url:
          'https://res.zailairen.com/msp/docs/2.0/2.9%20Valeon%20Summer%20School%20Introduction.pdf'
      },
      {
        targetMenteeType: 'LONG_TERM',
        title: 'Valeon School School List-2019',
        url:
          'https://res.zailairen.com/msp/docs/2.0/2.91%20Valeon%C2%A0Summer%C2%A0School%20List-2019.pdf'
      },
      {
        targetMenteeType: 'LONG_TERM',
        title: 'Valeon 海外本科交换项目教程',
        url:
          'https://res.zailairen.com/msp/docs/2.0/2.92%20Valeon%20%E6%B5%B7%E5%A4%96%E6%9C%AC%E7%A7%91%E4%BA%A4%E6%8D%A2%E9%A1%B9%E7%9B%AE%E7%94%B3%E8%AF%B7%E6%95%99%E7%A8%8B%20V1.0.pdf'
      },
      {
        targetMenteeType: 'LONG_TERM',
        attachments: [
          {
            targetMenteeType: 'LONG_TERM',
            title: '再来人海外暑研套磁信Template',
            url:
              'https://res.zailairen.com/msp/docs/2.0/2.94%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E6%B5%B7%E5%A4%96%E6%9A%91%E7%A0%94%E5%A5%97%E7%A3%81%E4%BF%A1Template.docx'
          }
        ],
        title: '再来人海外暑研套磁攻略',
        url:
          'https://res.zailairen.com/msp/docs/2.0/2.93%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E6%B5%B7%E5%A4%96%E6%9A%91%E7%A0%94%E5%A5%97%E7%A3%81%E6%94%BB%E7%95%A5%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'ALL',
        attachments: [
          {
            targetMenteeType: 'ALL',
            title: '再来人PhD项目套磁信Template',
            url:
              'https://res.zailairen.com/msp/docs/2.0/2.96%20%E5%86%8D%E6%9D%A5%E4%BA%BAPhD%E9%A1%B9%E7%9B%AE%E5%A5%97%E7%A3%81%E4%BF%A1Template.docx'
          }
        ],
        title: '再来人PhD项目套磁攻略',
        url:
          'https://res.zailairen.com/msp/docs/2.0/2.95%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BAPhD%E9%A1%B9%E7%9B%AE%E5%A5%97%E7%A3%81%E6%94%BB%E7%95%A5%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'LONG_TERM',
        attachments: [
          {
            targetMenteeType: 'LONG_TERM',
            title: 'J-1签证课件附件',
            url:
              'https://res.zailairen.com/msp/docs/2.0/2.98%20J-1%E7%AD%BE%E8%AF%81%E8%AF%BE%E4%BB%B6%E9%99%84%E4%BB%B6.rar'
          }
        ],
        title: '再来人美国海外暑研Visa Application Mentee Guide（J-1类）',
        url:
          'https://res.zailairen.com/msp/docs/2.0/2.97%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E7%BE%8E%E5%9B%BD%E6%B5%B7%E5%A4%96%E6%9A%91%E7%A0%94%20Visa%20Application%20Mentee%20Guide%20(J-1%E7%B1%BB)%20v1.0.doc.pdf'
      },
      {
        targetMenteeType: 'LONG_TERM',
        attachments: [
          {
            targetMenteeType: 'LONG_TERM',
            title: 'B类签证课件附件',
            url:
              'https://res.zailairen.com/msp/docs/2.0/2.991%20B%E7%B1%BB%E7%AD%BE%E8%AF%81%E8%AF%BE%E4%BB%B6%E9%99%84%E4%BB%B6.rar'
          }
        ],
        title: '再来人美国海外暑研Visa Application Mentee Guide（B类）',
        url:
          'https://res.zailairen.com/msp/docs/2.0/2.99%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E7%BE%8E%E5%9B%BD%E6%B5%B7%E5%A4%96%E6%9A%91%E7%A0%94%20Visa%20Application%20Mentee%20Guide%20(B%E7%B1%BB)%20v1.0%20(secured).doc.pdf'
      },
      {
        targetMenteeType: 'LONG_TERM',
        attachments: [
          {
            targetMenteeType: 'LONG_TERM',
            title: '中文CV Template_科研',
            url:
              'https://res.zailairen.com/msp/docs/2.0/2.993%20%E4%B8%AD%E6%96%87CV%20Template_%E7%A7%91%E7%A0%94.docx'
          },
          {
            targetMenteeType: 'LONG_TERM',
            title: '中文CV Template_实习',
            url:
              'https://res.zailairen.com/msp/docs/2.0/2.994%20%E4%B8%AD%E6%96%87CV%20Template_%E5%AE%9E%E4%B9%A0.docx'
          }
        ],
        title: '再来人中文CV制作Mentee Guide',
        url:
          'https://res.zailairen.com/msp/docs/2.0/2.992%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E4%B8%AD%E6%96%87CV%E5%88%B6%E4%BD%9CMentee%20Guide%20v1.0%20(secured).pdf'
      }
    ]
  },
  projectAndSchoolSelection: {
    title: '专业与选校定位',
    courseWareList: [
      {
        targetMenteeType: 'IN_SEASON',
        title: '再来人选校宝典-当季-电气工程硕士篇 v1.0',
        url:
          'https://res.zailairen.com/msp/docs/3.0/3.1%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E9%80%89%E6%A0%A1%E5%AE%9D%E5%85%B8-%E5%BD%93%E5%AD%A3-%E7%94%B5%E6%B0%94%E5%B7%A5%E7%A8%8B%E7%A1%95%E5%A3%AB%E7%AF%87%20v1.0%20(Secured).pdf'
      },
      {
        targetMenteeType: 'IN_SEASON',
        title: '再来人选校宝典-当季-计算机科学硕士篇 v1.0',
        url:
          'https://res.zailairen.com/msp/docs/3.0/3.2%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E9%80%89%E6%A0%A1%E5%AE%9D%E5%85%B8-%E5%BD%93%E5%AD%A3-%E8%AE%A1%E7%AE%97%E6%9C%BA%E7%A7%91%E5%AD%A6%E7%A1%95%E5%A3%AB%E7%AF%87%20v1.0%20(Secured).pdf'
      },
      {
        targetMenteeType: 'IN_SEASON',
        title: '再来人选校宝典-当季-金融工程硕士篇 v1.0',
        url:
          'https://res.zailairen.com/msp/docs/3.0/3.3%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E9%80%89%E6%A0%A1%E5%AE%9D%E5%85%B8-%E5%BD%93%E5%AD%A3-%E9%87%91%E8%9E%8D%E5%B7%A5%E7%A8%8B%E7%A1%95%E5%A3%AB%E7%AF%87%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'IN_SEASON',
        title: '再来人选校宝典-当季-金融硕士篇 v1.0',
        url:
          'https://res.zailairen.com/msp/docs/3.0/3.4%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E9%80%89%E6%A0%A1%E5%AE%9D%E5%85%B8-%E5%BD%93%E5%AD%A3-%E9%87%91%E8%9E%8D%E7%A1%95%E5%A3%AB%E7%AF%87%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'IN_SEASON',
        title: '再来人选校宝典-当季-数据分析硕士篇 v1.0',
        url:
          'https://res.zailairen.com/msp/docs/3.0/3.5%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E9%80%89%E6%A0%A1%E5%AE%9D%E5%85%B8-%E5%BD%93%E5%AD%A3-%E6%95%B0%E6%8D%AE%E5%88%86%E6%9E%90%E7%A1%95%E5%A3%AB%E7%AF%87%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'LONG_TERM',
        title: '再来人长线规划提升宝典-金融硕士篇 v1.0',
        url:
          'https://res.zailairen.com/msp/docs/3.0/3.6%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E9%95%BF%E7%BA%BF%E8%A7%84%E5%88%92%E6%8F%90%E5%8D%87%E5%AE%9D%E5%85%B8%20-%E9%87%91%E8%9E%8D%E7%A1%95%E5%A3%AB%E7%AF%87%20v1.0%20(Secured).pdf'
      }
    ]
  },
  basicApplyMaterials: {
    title: '基础申请材料',
    courseWareList: [
      {
        targetMenteeType: 'ALL',
        title: '再来人海外研究生项目申请材料清单',
        url:
          'https://res.zailairen.com/msp/docs/4.0/4.1%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E6%B5%B7%E5%A4%96%E7%A0%94%E7%A9%B6%E7%94%9F%E9%A1%B9%E7%9B%AE%E7%94%B3%E8%AF%B7%E6%9D%90%E6%96%99%E6%B8%85%E5%8D%95%20v1.0.pdf'
      },
      {
        targetMenteeType: 'ALL',
        attachments: [
          {
            targetMenteeType: 'ALL',
            title: '再来人成绩单WES官方认证 Mentee Guide 附件',
            url:
              'https://res.zailairen.com/msp/docs/4.0/4.4%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E6%88%90%E7%BB%A9%E5%8D%95WES%E5%AE%98%E6%96%B9%E8%AE%A4%E8%AF%81Mentee%20Guide%20%E9%99%84%E4%BB%B6.rar'
          }
        ],
        title: '再来人成绩单WES官方认证 Mentee Guide—未完成学位版 v2.0',
        url:
          'https://res.zailairen.com/msp/docs/4.0/%E5%86%8D%E6%9D%A5%E4%BA%BA%E6%88%90%E7%BB%A9%E5%8D%95WES%E5%AE%98%E6%96%B9%E8%AE%A4%E8%AF%81Mentee%20Guide%E2%80%94%E6%9C%AA%E5%AE%8C%E6%88%90%E5%AD%A6%E4%BD%8D%E7%89%88%20v2.0.pdf'
      },
      {
        targetMenteeType: 'ALL',
        attachments: [
          {
            targetMenteeType: 'ALL',
            title: '再来人成绩单WES官方认证 Mentee Guide 附件',
            url:
              'https://res.zailairen.com/msp/docs/4.0/4.4%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E6%88%90%E7%BB%A9%E5%8D%95WES%E5%AE%98%E6%96%B9%E8%AE%A4%E8%AF%81Mentee%20Guide%20%E9%99%84%E4%BB%B6.rar'
          }
        ],
        title: '再来人成绩单WES官方认证 Mentee Guide—已完成学位版 v2.0',
        url:
          'https://res.zailairen.com/msp/docs/4.0/%E5%86%8D%E6%9D%A5%E4%BA%BA%E6%88%90%E7%BB%A9%E5%8D%95WES%E5%AE%98%E6%96%B9%E8%AE%A4%E8%AF%81Mentee%20Guide%E2%80%94%E5%B7%B2%E5%AE%8C%E6%88%90%E5%AD%A6%E4%BD%8D%E7%89%88%20v2.0.pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人TOEFL官方送分Mentee Guide',
        url:
          'https://res.zailairen.com/msp/docs/4.0/4.5%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BATOEFL%E5%AE%98%E6%96%B9%E9%80%81%E5%88%86Mentee%20Guide%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人IELTS官方送分Mentee Guide',
        url:
          'https://res.zailairen.com/msp/docs/4.0/4.6%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BAIELTS%E5%AE%98%E6%96%B9%E9%80%81%E5%88%86Mentee%20Guide%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人GRE官方送分Mentee Guide',
        url:
          'https://res.zailairen.com/msp/docs/4.0/4.7%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BAGRE%E5%AE%98%E6%96%B9%E9%80%81%E5%88%86Mentee%20Guide%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人GMAT官方送分Mentee Guide',
        url:
          'https://res.zailairen.com/msp/docs/4.0/4.8%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BAGMAT%E5%AE%98%E6%96%B9%E9%80%81%E5%88%86Mentee%20Guide%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人网申系统操作Mentee Guide—Apply.grad',
        url:
          'https://res.zailairen.com/msp/docs/4.0/4.9%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E7%BD%91%E7%94%B3%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9CMentee%20Guide-Apply.grad%20v1.0.pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人网申系统操作Mentee Guide—Applyweb',
        url:
          'https://res.zailairen.com/msp/docs/4.0/4.91%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E7%BD%91%E7%94%B3%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9CMentee%20Guide-Applyweb%20v1.0.pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人网申系统操作Mentee Guide—Applyyourself',
        url:
          'https://res.zailairen.com/msp/docs/4.0/4.92%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E7%BD%91%E7%94%B3%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9CMentee%20Guide-Applyyourself%20v1.0.pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人网申系统操作Mentee Guide—Liaisioncas',
        url:
          'https://res.zailairen.com/msp/docs/4.0/4.93%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E7%BD%91%E7%94%B3%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9CMentee%20Guide-Liaisioncas%20v1.0.pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人网申系统操作Mentee Guide—英国院校',
        url:
          'https://res.zailairen.com/msp/docs/4.0/4.94%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E7%BD%91%E7%94%B3%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9CMentee%20Guide-%E8%8B%B1%E5%9B%BD%E9%99%A2%E6%A0%A1%20v1.0.pdf'
      }
    ]
  },
  essayApply: {
    title: '申请文书辅导',
    courseWareList: [
      {
        targetMenteeType: 'ALL',
        title: '再来人文书宝典Level I：申请文书概述',
        url:
          'https://res.zailairen.com/msp/docs/5.0/5.1%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E6%96%87%E4%B9%A6%E5%AE%9D%E5%85%B8%20LEVEL%20I%20%EF%BC%9A%E7%94%B3%E8%AF%B7%E6%96%87%E4%B9%A6%E6%A6%82%E8%BF%B0%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人文书宝典Level II：如何让你的PS & Essay征服招生官',
        url:
          'https://res.zailairen.com/msp/docs/5.0/5.2%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E6%96%87%E4%B9%A6%E5%AE%9D%E5%85%B8%20LEVEL%20II%EF%BC%9A%E5%A6%82%E4%BD%95%E8%AE%A9%E4%BD%A0%E7%9A%84PS%20%26%20Essay%E5%BE%81%E6%9C%8D%E6%8B%9B%E7%94%9F%E5%AE%98%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人文书宝典Level III：如何制作高质量CV及成功CV范例',
        url:
          'https://res.zailairen.com/msp/docs/5.0/5.3%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E6%96%87%E4%B9%A6%E5%AE%9D%E5%85%B8%20LEVEL%20III%EF%BC%9A%E5%A6%82%E4%BD%95%E5%88%B6%E4%BD%9C%E9%AB%98%E8%B4%A8%E9%87%8FCV%E5%8F%8A%E6%88%90%E5%8A%9FCV%E8%8C%83%E4%BE%8B%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'ALL',
        title:
          '再来人文书宝典Level IV-A：如何获取“牛推”及成功推荐信范文（博士项目）',
        url:
          'https://res.zailairen.com/msp/docs/5.0/5.4%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E6%96%87%E4%B9%A6%E5%AE%9D%E5%85%B8%20LEVEL%20IV-A%20%E5%A6%82%E4%BD%95%E8%8E%B7%E5%8F%96%E2%80%9C%E7%89%9B%E6%8E%A8%E2%80%9D%E5%8F%8A%E6%88%90%E5%8A%9F%E6%8E%A8%E8%8D%90%E4%BF%A1%E8%8C%83%E6%96%87%EF%BC%88%E5%8D%9A%E5%A3%AB%E9%A1%B9%E7%9B%AE%EF%BC%89%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'ALL',
        title:
          '再来人文书宝典Level IV-B：如何获取“牛推”及成功推荐信范文（硕士项目）',
        url:
          'https://res.zailairen.com/msp/docs/5.0/5.5%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E6%96%87%E4%B9%A6%E5%AE%9D%E5%85%B8%20LEVEL%20IV-B%20%E5%A6%82%E4%BD%95%E8%8E%B7%E5%8F%96%E2%80%9C%E7%89%9B%E6%8E%A8%E2%80%9D%E5%8F%8A%E6%88%90%E5%8A%9F%E6%8E%A8%E8%8D%90%E4%BF%A1%E8%8C%83%E6%96%87%EF%BC%88%E7%A1%95%E5%A3%AB%E9%A1%B9%E7%9B%AE%EF%BC%89%20v1.0%20(secured).pdf'
      }
    ]
  },
  waitingListAndMockInterview: {
    title: '等待名单与模拟面试',
    courseWareList: [
      {
        targetMenteeType: 'ALL',
        title: '再来人等待名单攻略 ',
        url:
          'https://res.zailairen.com/msp/docs/6.0/6.1%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E7%AD%89%E5%BE%85%E5%90%8D%E5%8D%95%E6%94%BB%E7%95%A5%20v1.0.pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人就业导向Interview Tips（In-person）',
        url:
          'https://res.zailairen.com/msp/docs/6.0/2021/2021%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E5%B0%B1%E4%B8%9A%E5%AF%BC%E5%90%91Interview%20Tips%20%28In-person%29%20v1.0%20%28secured%29.pdf',
        password: 'Zailairen21'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人就业导向Interview Tips（Skype）',
        url:
          'https://res.zailairen.com/msp/docs/6.0/2021/2021%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E5%B0%B1%E4%B8%9A%E5%AF%BC%E5%90%91Interview%20Tips%20%28Skype%29%20v1.0%20%28secured%29.pdf',
        password: 'Zailairen21'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人学术导向Interview Tips（In-person）',
        url:
          'https://res.zailairen.com/msp/docs/6.0/2021/2021%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E5%AD%A6%E6%9C%AF%E5%AF%BC%E5%90%91Interview%20Tips%20%28In-person%29%20v1.0%20%28secured%29.pdf',
        password: 'Zailairen21'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人学术导向Interview Tips（Skype）',
        url:
          'https://res.zailairen.com/msp/docs/6.0/2021/2021%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E5%AD%A6%E6%9C%AF%E5%AF%BC%E5%90%91Interview%20Tips%20%28Skype%29%20v1.0%20%28secured%29.pdf',
        password: 'Zailairen21'
      }
    ]
  },
  embarkNewJourney: {
    title: '开启新征程',
    courseWareList: [
      {
        targetMenteeType: 'ALL',
        title: '再来人“录取后时代”Mentee Guide（US）',
        url:
          'https://res.zailairen.com/msp/docs/7.0/7.1%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E2%80%9C%E5%BD%95%E5%8F%96%E5%90%8E%E6%97%B6%E4%BB%A3%E2%80%9D%20Mentee%20Guide%20(US)%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人“录取后时代”Mentee Guide（UK）',
        url:
          'https://res.zailairen.com/msp/docs/7.0/7.2%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E2%80%9C%E5%BD%95%E5%8F%96%E5%90%8E%E6%97%B6%E4%BB%A3%E2%80%9D%20Mentee%20Guide%20(UK)%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人Offer选择攻略：你不能错过的Offer选择Tips—科研路线',
        url:
          'https://res.zailairen.com/msp/docs/7.0/7.3%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BAOffer%E9%80%89%E6%8B%A9%E6%94%BB%E7%95%A5%EF%BC%9A%E4%BD%A0%E4%B8%8D%E8%83%BD%E9%94%99%E8%BF%87%E7%9A%84Offer%E9%80%89%E6%8B%A9Tips%20-%20%E7%A7%91%E7%A0%94%E8%B7%AF%E7%BA%BF%20v1.0%20(secure).pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人Offer选择攻略：你不能错过的Offer选择Tips—职业路线',
        url:
          'https://res.zailairen.com/msp/docs/7.0/7.4%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BAOffer%E9%80%89%E6%8B%A9%E6%94%BB%E7%95%A5%EF%BC%9A%E4%BD%A0%E4%B8%8D%E8%83%BD%E9%94%99%E8%BF%87%E7%9A%84Offer%E9%80%89%E6%8B%A9Tips%20-%20%E8%81%8C%E4%B8%9A%E8%B7%AF%E7%BA%BF%20v1.0%20(secure).pdf'
      },
      {
        targetMenteeType: 'ALL',
        attachments: [
          {
            targetMenteeType: 'ALL',
            title: 'F-1签证课件附件',
            url:
              'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/F-1%E7%AD%BE%E8%AF%81%E8%B5%84%E6%96%99%E9%99%84%E4%BB%B6.rar'
          }
        ],
        title: '再来人F-1 Visa Application Mentee Guide-Master',
        password: 'Zailairen20',
        url:
          'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/2020%20%E5%86%8D%E6%9D%A5%E4%BA%BAF-1%20Visa%20Application%20Mentee%20Guide-Master%20v1.1.pdf'
      },
      {
        targetMenteeType: 'ALL',
        attachments: [
          {
            targetMenteeType: 'ALL',
            title: 'F-1签证课件附件',
            url:
              'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/F-1%E7%AD%BE%E8%AF%81%E8%B5%84%E6%96%99%E9%99%84%E4%BB%B6.rar'
          }
        ],
        title: '再来人F-1 Visa Application Mentee Guide-PhD',
        password: 'Zailairen20',
        url:
          'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/2020%20%E5%86%8D%E6%9D%A5%E4%BA%BAF-1%20Visa%20Application%20Mentee%20Guide-PhD%20v1.1.pdf'
      },
      {
        targetMenteeType: 'ALL',
        attachments: [
          {
            targetMenteeType: 'ALL',
            title: 'UK签证课件附件',
            url:
              'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/%E8%8B%B1%E5%9B%BDTier-4%E5%AD%A6%E7%94%9F%E7%AD%BE%E8%AF%81%E8%B5%84%E6%96%99%E9%99%84%E4%BB%B6.rar'
          }
        ],
        title: '再来人UK Visa Application Mentee Guide ',
        password: 'Zailairen20',
        url:
          'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/2020%E5%86%8D%E6%9D%A5%E4%BA%BAUK%20Visa%20Application%20Mentee%20Guide%20V1.1.pdf'
      },
      {
        targetMenteeType: 'ALL',
        attachments: [
          {
            targetMenteeType: 'ALL',
            title: '加拿大签证课件附件',
            url:
              'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/0714/%E5%8A%A0%E6%8B%BF%E5%A4%A7%E7%AD%BE%E8%AF%81Pack.zip'
          }
        ],
        title: '再来人加拿大签证Mentee Guide v1.0',
        password: 'Zailairen20',
        url:
          'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/0714/2020%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E5%8A%A0%E6%8B%BF%E5%A4%A7%E7%AD%BE%E8%AF%81%20Mentee%20Guide%20v1.0%20%28secured%29.pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '再来人海外院校奖学金申请指南',
        url:
          'https://res.zailairen.com/msp/docs/7.0/7.91%202019%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E6%B5%B7%E5%A4%96%E9%99%A2%E6%A0%A1%E5%A5%96%E5%AD%A6%E9%87%91%E7%94%B3%E8%AF%B7%E6%8C%87%E5%8D%97%20v1.0%20(secured).pdf'
      },
      {
        targetMenteeType: 'ALL',
        title:
          '2020 再来人离境辅导系列手册（之一）：美国入境及转机攻略 v1.0 (secured).pdf',
        password: 'Zailairen20',
        url:
          'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/0628/2020%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E7%A6%BB%E5%A2%83%E8%BE%85%E5%AF%BC%E7%B3%BB%E5%88%97%E6%89%8B%E5%86%8C%EF%BC%88%E4%B9%8B%E4%B8%80%EF%BC%89%EF%BC%9A%E7%BE%8E%E5%9B%BD%E5%85%A5%E5%A2%83%E5%8F%8A%E8%BD%AC%E6%9C%BA%E6%94%BB%E7%95%A5%20v1.0%20%28secured%29.pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '2020 再来人离境辅导系列手册（之二）：美国住宿攻略 v1.0 (secured).pdf',
        password: 'Zailairen20',
        url:
          'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/0628/2020%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E7%A6%BB%E5%A2%83%E8%BE%85%E5%AF%BC%E7%B3%BB%E5%88%97%E6%89%8B%E5%86%8C%EF%BC%88%E4%B9%8B%E4%BA%8C%EF%BC%89%EF%BC%9A%E7%BE%8E%E5%9B%BD%E4%BD%8F%E5%AE%BF%E6%94%BB%E7%95%A5%20v1.0%20%28secured%29.pdf'
      },
      {
        targetMenteeType: 'ALL',
        title:
          '2020 再来人离境辅导系列手册（之三）：美国电话卡开通攻略 v1.0 (secured).pdf',
        password: 'Zailairen20',
        url:
          'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/0628/2020%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E7%A6%BB%E5%A2%83%E8%BE%85%E5%AF%BC%E7%B3%BB%E5%88%97%E6%89%8B%E5%86%8C%EF%BC%88%E4%B9%8B%E4%B8%89%EF%BC%89%EF%BC%9A%E7%BE%8E%E5%9B%BD%E7%94%B5%E8%AF%9D%E5%8D%A1%E5%BC%80%E9%80%9A%E6%94%BB%E7%95%A5%20v1.0%20%28secured%29.pdf'
      },
      {
        targetMenteeType: 'ALL',
        title:
          '2020 再来人离境辅导系列手册（之四）：美国银行卡开通攻略 v1.0 (secured).pdf',
        password: 'Zailairen20',
        url:
          'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/0628/2020%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E7%A6%BB%E5%A2%83%E8%BE%85%E5%AF%BC%E7%B3%BB%E5%88%97%E6%89%8B%E5%86%8C%EF%BC%88%E4%B9%8B%E5%9B%9B%EF%BC%89%EF%BC%9A%E7%BE%8E%E5%9B%BD%E9%93%B6%E8%A1%8C%E5%8D%A1%E5%BC%80%E9%80%9A%E6%94%BB%E7%95%A5%20v1.0%20%28secured%29.pdf'
      },
      {
        targetMenteeType: 'ALL',
        title:
          '2020 再来人离境辅导系列手册（之五）：美国公共交通及出行攻略 v1.0 (secured).pdf',
        password: 'Zailairen20',
        url:
          'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/0628/2020%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E7%A6%BB%E5%A2%83%E8%BE%85%E5%AF%BC%E7%B3%BB%E5%88%97%E6%89%8B%E5%86%8C%EF%BC%88%E4%B9%8B%E4%BA%94%EF%BC%89%EF%BC%9A%E7%BE%8E%E5%9B%BD%E5%85%AC%E5%85%B1%E4%BA%A4%E9%80%9A%E5%8F%8A%E5%87%BA%E8%A1%8C%E6%94%BB%E7%95%A5%20v1.0%20%28secured%29.pdf'
      },
      {
        targetMenteeType: 'ALL',
        password: 'Zailairen20',
        title:
          '2020 再来人离境辅导系列手册（之六）：美国驾照考取及购车攻略 v1.0 (secured).pdf',
        url:
          'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/0628/2020%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E7%A6%BB%E5%A2%83%E8%BE%85%E5%AF%BC%E7%B3%BB%E5%88%97%E6%89%8B%E5%86%8C%EF%BC%88%E4%B9%8B%E5%85%AD%EF%BC%89%EF%BC%9A%E7%BE%8E%E5%9B%BD%E9%A9%BE%E7%85%A7%E8%80%83%E5%8F%96%E5%8F%8A%E8%B4%AD%E8%BD%A6%E6%94%BB%E7%95%A5%20v1.0%20%28secured%29.pdf'
      },
      {
        targetMenteeType: 'ALL',
        title: '2020 再来人英国行前辅导手册v1.0 (secured).pdf',
        password: 'Zailairen20',
        url:
          'https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/7.0/0628/2020%20%E5%86%8D%E6%9D%A5%E4%BA%BA%E8%8B%B1%E5%9B%BD%E8%A1%8C%E5%89%8D%E8%BE%85%E5%AF%BC%E6%89%8B%E5%86%8Cv1.0%20%28secured%29.pdf'
      }
    ]
  }
}
